'use client'

import type { PropsWithChildren } from 'react'

import { SpaceLayoutClient as SharedSpaceLayoutClient } from '@/components/space/space-layout-client'
import { SceneID } from '@/enums/agent'

interface SpaceLayoutClientProps extends PropsWithChildren {
  defaultOpen?: boolean
}

/**
 * Seedance 页面布局客户端组件
 * 使用公共的 SpaceLayoutClient，配置 basePath 为 /seedance，默认模型为 SEEDANCE2（可切换其他模型）
 */
export const SpaceLayoutClient = ({ children, defaultOpen = true }: SpaceLayoutClientProps) => {
  return (
    <SharedSpaceLayoutClient
      config={{ basePath: '/seedance', defaultModelId: SceneID.SEEDANCE2 }}
      defaultOpen={defaultOpen}
    >
      {children}
    </SharedSpaceLayoutClient>
  )
}
